// R-2 (queue 32): which old signature files may be removed after a Report Branding save. Pure, so the guard that keeps a
// storage delete inside its lane is unit-tested as shipped. Rulings: delete only after the settings row is confirmed
// (the caller), never the saved path, never null, never outside the caller's own folder — and only the top-level
// report_signature_<ts>.png|jpg files there (the folder also holds report_logo_* and reports/<id>/final-*.pdf).
const SIG_RE = /^report_signature_\d+\.(png|jpg)$/;

// uid = the signed-in user's id; saved = the path the row now holds (confirmed); candidates = paths that may be orphaned
export function removableSignaturePaths({ uid, saved, candidates }) {
  const out = new Set();
  if (!uid || typeof uid !== 'string') return [];
  for (const p of candidates || []) {
    if (!p || typeof p !== 'string' || p === saved) continue;   // null / the one the row holds now
    if (!p.startsWith(uid + '/')) continue;                     // outside the caller's own folder
    const rest = p.slice(uid.length + 1);
    if (rest.includes('/') || !SIG_RE.test(rest)) continue;     // only top-level report_signature_* files
    out.add(p);
  }
  return [...out];
}

// F-7 (R-2 for the logo): the same guard for the branding LOGO. Only the top-level report_logo_<ts>.png|jpg|jpeg files of the caller's own
// folder (case-insensitive extension); never a signature, a report PDF, a nested path, another user's file, null, or the saved path.
const LOGO_RE = /^report_logo_\d+\.(png|jpe?g)$/i;
export function removableLogoPaths({ uid, saved, candidates }) {
  const out = new Set();
  if (!uid || typeof uid !== 'string') return [];
  for (const p of candidates || []) {
    if (!p || typeof p !== 'string' || p === saved) continue;
    if (!p.startsWith(uid + '/')) continue;
    const rest = p.slice(uid.length + 1);
    if (rest.includes('/') || !LOGO_RE.test(rest)) continue;
    out.add(p);
  }
  return [...out];
}
